import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import {
  SELECT_ITEM_INDICATOR_ICON,
  type TSelectItemElement,
  type TSelectItemProps,
} from "@/ui/components/form/Select/Select.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const SelectItem = forwardRef<TSelectItemElement, TSelectItemProps>(
  (
    {
      children,
      className,
      icon,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.Item
      data-component="SelectItem"
      ref={ref}
      className={cn(
        "relative flex w-full cursor-default select-none items-center rounded-sys-sm py-1.5 pr-8 outline-none",
        icon ? "pl-8" : "pl-2",
        "focus:bg-component-select-item-focused focus:text-foreground-default",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className,
      )}
      {...props}
    >
      { icon ? (
        <span
          data-component="SelectItemIcon"
          className="absolute left-2 flex h-4 w-4 items-center justify-center"
        >
          <Icon
            icon={icon}
            aria-hidden="true"
            size="sm"
          />
        </span>
      ) : null }
      <span
        data-component="SelectItemIndicator"
        className="absolute right-2 flex h-4 w-4 items-center justify-center"
      >
        <SelectPrimitive.ItemIndicator>
          <Icon
            icon={SELECT_ITEM_INDICATOR_ICON}
            aria-hidden="true"
            size="sm"
          />
        </SelectPrimitive.ItemIndicator>
      </span>
      <SelectPrimitive.ItemText data-component="SelectItemText">
        <TextBody tag="span" size={2} isResponsive={false}>
          { children }
        </TextBody>
      </SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  ),
);

SelectItem.displayName = SelectPrimitive.Item.displayName;
